import { Checkbox } from '@lingoda/forms';
import { Box, Typography } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { TermsLink } from '@lingoda/legal';
import { AgreementsForm } from './AgreementsForm';
import { type CheckoutAgreements } from './types';

interface AgreementsProps {
    agreements: CheckoutAgreements;
    showRevocationLink?: boolean;
}

export const Agreements = ({ agreements, showRevocationLink }: AgreementsProps) => (
    <Box>
        <Checkbox
            name="termsAndConditions"
            label={<TermsLink showRevocationLink={showRevocationLink} />}
        />
        {!!agreements.length && <AgreementsForm agreements={agreements} />}
        <Checkbox
            name="ageAboveEighteen"
            label={
                <Typography variant="body2">
                    {trans('i-confirm-i-am-above-eighteen-years-old', {}, 'public-payment')}
                </Typography>
            }
        />
    </Box>
);
